"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LoginModalHelper = (function () {
    function LoginModalHelper() {
    }
    LoginModalHelper.bind = function (user) {
        user.username = String($('.user-username').val());
        user.password = String($('.user-password').val());
        return user;
    };
    ;
    LoginModalHelper.clearloginInputs = function () {
        $('.user-username').val('');
        $('.user-password').val('');
        $('.login-error-block').empty();
    };
    ;
    LoginModalHelper.logErorr = function (error) {
        $('.login-error-block').html(error);
    };
    LoginModalHelper.closeModal = function () {
        $('.login-modal').modal('hide');
    };
    return LoginModalHelper;
}());
exports.default = LoginModalHelper;



//////////////////
// WEBPACK FOOTER
// ./src/games/video-roulette/ts/helpers/login-modal-helper.ts
// module id = 377
// module chunks = 10